import { render, staticRenderFns } from "./notes-detail.vue?vue&type=template&id=9543a3e8&"
import script from "./notes-detail.vue?vue&type=script&lang=js&"
export * from "./notes-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports